import type { BuyRequest, IRogue } from '@/js/services/RogueTypes'
import { findEnabledCustomProductVariantBySku, lineSku } from './registry'

// Rides in `metadata.notifyLayout`, which m2-checkout whitelists onto the order and then strips before publishing to m2-appdev.
export function getNotifyLayout(rogue: IRogue, buyRequest: BuyRequest, parent?: BuyRequest): Record<string, string> | undefined {
  if (!parent) return undefined

  const sku = lineSku(rogue, parent)
  const variant = findEnabledCustomProductVariantBySku(rogue, sku)

  if (!sku || !variant?.emailLayout || !variant.skuSets.itemSkus.includes(sku)) return undefined

  const layout = variant.emailLayout(rogue, parent, buyRequest)

  return layout && Object.keys(layout).length ? layout : undefined
}
